module.exports = __webpack_public_path__ + "img/fams.e6e5703f.png";